<div class="transport-list">
  @if (dataSource.data.length == 0) {
  <sc-no-data fitHeight class="no-data"></sc-no-data>
  }
  <sc-scroll-pane (onScroll)="handleScroll($event)">
    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortChanged($event)" class="transport-table">

      <ng-container matColumnDef="hint">

        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.hint"></sc-dictionary-label>
        </th>

        <td mat-cell *matCellDef="let transport" [ngClass]="{'selected' : transport.id === selectedId }"
          class="hint-column {{transport.currentThemingRule && transport.id !== selectedId ? 'theming-rule-' + transport.currentThemingRule : 'no-theming-rule'}}">
          <sc-flex>

            <app-transport-scope-icon [scope]="transport.transportScope"
              [type]="transport.transportType"></app-transport-scope-icon>

            @if (transport.useGlobalConnect) {
            <sc-content-spacer [half]="true"></sc-content-spacer>
            <sc-icon iconClass="fa-qrcode"></sc-icon>
            }

            @if (transport.useSms) {
            <sc-content-spacer [half]="true"></sc-content-spacer>
            <sc-icon iconClass="fa-message-sms"></sc-icon>
            }

            @if (transport.usePager) {
            <sc-content-spacer [half]="true"></sc-content-spacer>
            <sc-icon iconClass="fa-wifi"></sc-icon>
            }

            @if (transport.important) {
            <sc-content-spacer [half]="true"></sc-content-spacer>
            <sc-icon iconClass="fa-exclamation"></sc-icon>
            }

            @if (transport.urgent) {
            <sc-content-spacer [half]="true"></sc-content-spacer>
            <sc-icon iconClass="fa-truck-fast"></sc-icon>
            }

            @if (transport.intermitted) {
            <sc-content-spacer [half]="true"></sc-content-spacer>
            <sc-icon iconClass="fa-octagon-xmark"></sc-icon>
            }

            @if (transport.inUmbrueckung) {
            <sc-content-spacer [half]="true"></sc-content-spacer>
            <sc-icon iconClass="fa-shuffle"></sc-icon>
            }

            @if (transport.dangerousGoods) {
            <sc-content-spacer [half]="true"></sc-content-spacer>
            <sc-icon iconClass="fa-skull-crossbones"></sc-icon>
            }

            @if (transport.pendingTaskState !== PendingTaskState.NONE) {
            <sc-content-spacer [half]="true"></sc-content-spacer>
            <app-task-state-icon [state]="transport.pendingTaskState"></app-task-state-icon>
            }

            @if (transport.hasMovementOrder) {
            <sc-content-spacer [half]="true"></sc-content-spacer>
            <sc-icon iconClass="fa-truck-flatbed"></sc-icon>
            }

          </sc-flex>
        </td>
      </ng-container>

      @for (detail of possibleColumns; track detail) {
      <ng-container [matColumnDef]="detail.identifier">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.{{detail.attribute}}"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection {{detail.dataType}} {{detail.identifier}}-column {{transport.currentThemingRule && transport.id !== selectedId ? 'theming-rule-' + transport.currentThemingRule : 'no-theming-rule'}}"
          *matCellDef="let transport" [ngClass]="{'selected' : transport.id === selectedId}">
          <span class="value">
            {{ transport[detail.identifier] | transportColumnFormat:[detail] }}
          </span>
        </td>
      </ng-container>
      }

      <ng-container matColumnDef="filler">
        <th mat-header-cell *matHeaderCellDef style="width: 100%;"> &nbsp; </th>
        <td mat-cell *matCellDef="let transport" [ngClass]="{'selected' : transport.id === selectedId}"
          class="{{transport.statusStyle}}"> &nbsp;</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>

      <tr mat-row *matRowDef="let transport; columns: columnsToDisplay" [attr.data-transport-id]="transport.id"
        [ngClass]="[transport.highlightingStyle, transport.tableRowStyles]" (click)="onClickRow(transport)"></tr>

    </table>
  </sc-scroll-pane>
</div>
